import * as React from "react";
//#region types
import { useContent } from "serviceHooks/useContent";
import { Status } from "../../../api/types/Status";
//#endregion
//#region components
import { useFloatingMessages } from "components/common";
//#endregion
//#region types
import { StyleEnums } from "models/enums";
//#endregion

/**
 * Component to display status messages (driftmeddelanden) as a snackbar message
 * Fetches content from /api/content?slug=status
 * This message persists and does not disappear automatically
 */
const StatusMessage: React.FC = () => {
  const { content, loading } = useContent<Status>("status");
  const { enqueueMessage } = useFloatingMessages();

  React.useEffect(() => {
    // Don't show anything if loading or no content
    if (loading || !content || content.length === 0) {
      return;
    }

    // Get the first status message (assuming there's typically one active status)
    const statusItem = content[0];

    // Extract message from 'text' field
    const message = statusItem.text || "";

    // Don't show if there's no message content
    if (!message) {
      return;
    }

    // Determine display type based on 'type' field (default to Warning)
    let displayType = StyleEnums.DisplayType.Warning;
    if (statusItem.type === "error") {
      displayType = StyleEnums.DisplayType.Danger;
    } else if (statusItem.type === "info") {
      displayType = StyleEnums.DisplayType.Info;
    } else if (statusItem.type === "warning") {
      displayType = StyleEnums.DisplayType.Warning;
    }

    // Show snackbar message that persists (does not auto-hide)
    enqueueMessage(message, displayType, false, true, {
      preventDuplicate: true,
    });
  }, [content, loading, enqueueMessage]);

  // This component doesn't render anything - it only triggers the snackbar
  return null;
};

export default StatusMessage;
